import React, { useState, useEffect, memo } from 'react';
import { Button, Box, Chip, Divider, useMediaQuery } from '@material-ui/core';
import PostAddIcon from '@material-ui/icons/PostAdd';
import { PageContainer } from 'components/PageContainer';

import jwtDecode from 'jwt-decode';

import { useRoutes } from 'hooks';
import { useRecoilState } from 'recoil';
import { paginationIndexAtom } from 'atoms/atoms';
import { getAllCategory } from 'requests/category';
import { deletePost, getAllPosts } from 'requests/postsApi';
import { useHomeStore } from 'context/HomeStore';
import { LoaderBackdrop } from 'asterX-UI/Loaders';
import { ADMIN_PATH } from 'routes/constants.routes';
import NewsItem from './components/News/layout/NewsItem';
import { Pagination } from 'asterX-UI/Pagination';

const Home = () => {
  const { homeStoreFunc } = useHomeStore();
  const { goTo } = useRoutes();

  const [isLoading, setIsLoading] = useState(false);
  const [newsList, setNewsList] = useState([]);
  const [pageCount, setPageCount] = useState(1);
  const [paginationIndex, setPaginationIndex] = useRecoilState(paginationIndexAtom);
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md'));
  const decodedToken = jwtDecode(localStorage.getItem('access_token'));
  const userRole = decodedToken.roleList.find((f) => f.project.code === 'NEWS');
  const isAdmin = userRole?.code === 'ADMIN';

  const [allCategory, setAllCategory] = useState([]);
  const [categoryCode, setCategoryCode] = useState('');

  useEffect(() => {
    getAllCategories();
  }, []);

  const getAllCategories = async () => {
    try {
      const res = await getAllCategory();
      if (res && !res.message) {
        setAllCategory(res);
      }
    } catch (error) {
      console.error(error);
      setAllCategory([]);
    }
  };

  const fetchNewsList = async () => {
    try {
      const data = {
        category: categoryCode,
        offset: paginationIndex * 10,
        limit: 10,
      };
      const res = await getAllPosts(data);

      if (res) {
        setNewsList(res);
        setPageCount(Math.ceil(res?.count / 10));
      }
    } catch (error) {
      console.error(error);
    }
  };

  const onPaginationChange = (e, page) => {
    setIsLoading(true);
    page = page === 0 ? page : page - 1;
    setPaginationIndex(page);
    homeStoreFunc.onPaginationChange(page);
    setIsLoading(false);
  };

  useEffect(() => {
    const scrollTop = async () => {
      await window?.scrollTo({
        top: 0,
        behavior: 'auto',
      });
    };
    scrollTop();
  }, [newsList]);

  const handleClick = (code) => {
    if (categoryCode === code) {
      setCategoryCode('');
    } else {
      setCategoryCode(code);
    }
  };

  useEffect(() => {
    fetchNewsList();
  }, [paginationIndex, categoryCode]);

  const postNews = () => {
    goTo(`${ADMIN_PATH}`);
  };

  const handleDelete = async (id) => {
    try {
      setIsLoading(true);
      await deletePost(id);
      const updatedPosts = await getAllPosts({ category: categoryCode, offset: 0, limit: 10 });
      setNewsList(updatedPosts);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <PageContainer>
      <Box display='flex' justifyContent='flex-end' style={{ padding: '0 20px 0 20px', alignItems: 'center' }}>
        {isAdmin && (
          <Button variant={'contained'} size={'medium'} style={{ width: isMobile && '100%', margin: '20px 0 ' }} onClick={postNews}>
            <PostAddIcon fontSize={'small'} /> Cоздать Новость
          </Button>
        )}
      </Box>
      {isAdmin && <Divider style={{ marginTop: '20px', marginBottom: '20px' }} />}
      <Box style={{ padding: '0 20px 20px 20px' }}>
        <Box display='flex' flexWrap='wrap' justifyContent='flex-start'>
          <Box marginRight={2} marginBottom={2}>
            <Chip label='Все разделы' color={categoryCode === '' ? 'secondary' : 'primary'} onClick={() => handleClick('')}></Chip>
          </Box>
          {(allCategory || []).map((res) => (
            <Box key={res.id} marginRight={2} marginBottom={2}>
              <Chip label={res.name} color={categoryCode === res.code ? 'secondary' : 'primary'} onClick={() => handleClick(res.code)}></Chip>
            </Box>
          ))}
        </Box>
      </Box>

      <LoaderBackdrop loading={!!isLoading} />
      <Box display='flex' flexDirection='column'>
        <Box>
          {((newsList && newsList?.list) || []).map((news) => (
            <NewsItem {...news} key={`post-${news.id}`} onDelete={handleDelete} />
          ))}
        </Box>

        <Box mb={10} mt={10}>
          <Pagination count={pageCount} page={paginationIndex + 1} onChange={onPaginationChange} isMobile={isMobile} />
        </Box>
      </Box>
    </PageContainer>
  );
};

export default memo(Home);
